import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import dateConverter from '../../../../utils/converters/date.converter';
import { i18n } from "../../../vue-i18n";

export default class SetExtension {
  constructor(assetComponentId, extension) {
    this.commandName = "SetExtension";

    this.assetComponentId = assetComponentId;
    this.extension = extension;

    if (this.extension == null) {
      this.description = `${i18n.t ('CONTENT.events.no_extension')}`
    } else if (this.extension.isSure) {
      const convertedDate = dateConverter.convertToDate(this.extension.date);
      this.description =
        `${i18n.t ('CONTENT.events.isSureOnDate')} ${i18n.d(convertedDate)}`
    } else {
      this.description = `${i18n.t('CONTENT.events.isNotSure')}`
    }
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        NewExtension: this.extension
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
